<template>
    <el-button icon="el-icon-search" style="margin-left:20px;" @click="searchEvent"></el-button>
</template>
<script>
export default {
    methods:{
        searchEvent(){
            this.$router.push({
                name:'cardSite'
            })
        }
    }
}
</script>